export default {
  'component.globalHeader.help': 'مساعدة',
  'component.globalHeader.notification': 'الإشعارات',
  'component.globalHeader.notification.empty': 'ليس لديك إشعارات',
  'component.globalHeader.message': 'الرسائل',
  'component.globalHeader.event': 'الأحداث',
};
